import {calculateDiscountAmount} from "./commonHelper";
import downloadIcon from "../../Resources/Image/sd-download.svg"
import {sanitize} from "./thirdPartyUsageCSVDownloadHelper";

const csvRowHeader = ["Company Name", "Admin Name", "Plan","Total Usage Billed($)", "Has Paid","Your Earning($)"];

export const getEarningCSVDataLink = (fileName, paymentData, accountData, discount) => {
    fileName += ".csv";
    let blob = new Blob([createCSVRows(paymentData, accountData, discount)], {type: "text/csv"});
    let url = window.URL.createObjectURL(blob);
    return (
        <a className="downloadBtn" href={url} download={fileName} title={"Download Details"}>
            <img src={downloadIcon} alt={"CSV Download"}/>
        </a>
    );
}

const createCSVRows = (paymentData, accountData, discount) => {
    let rowString = csvRowHeader.join(",");
    rowString += "\n";
    paymentData.forEach((entry) => {
        let row = [];
        let accountDetails = accountData[entry.companyId];
        let discountAmount = calculateDiscountAmount(entry.billableAmount, discount);
        let isPaidText = "Yes";
        if (entry.isPaid === false) {
            discountAmount = 0;
            isPaidText = "No";
        }
        row.push(sanitize(accountDetails.companyName), accountDetails.adminName, entry.subscriptionPlan, entry.billableAmount, isPaidText, discountAmount);
        let newRow = row.join(",");
        rowString += newRow + "\r\n";
    })
    return rowString;
}

